module.exports = __webpack_public_path__ + "media/images/common/avatar3-dd6a53b20fc2c29510885322a1c30022.png";